export const JsonNumWictory =[
        {id: 1, num: 31},
        {id: 2, num: 32},
        {id: 3, num: 21},
        {id: 4, num: 12},
        {id: 5, num: 7},
    ]

export const  JsonNumComdinations = [
        {id: 1},
        {id: 2},
        {id: 3},
        {id: 4},
        {id: 5},
        {id: 6},
]

